import { BaseApiService } from "../base/base-api.service";
import { LegalEntityClientDTO, LegalEntityClientSTO } from "../../models/legal-entity-clients";
import { ListSortDirection, Sort } from "../../models/api/sort";
import { PropsFilter } from "src/models/api/props-filter";
import { LoadResponse } from "src/models/api/load";

export class LegalEntityClientsApiService extends BaseApiService<LegalEntityClientDTO, LegalEntityClientSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityClients",
      loadItemsPath: "/GetLegalEntityClients",
      saveItemsPath: "/SaveLegalEntityClients",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }

  public getClientByEmployeeGroup = async (propsFilter: PropsFilter): Promise<LoadResponse<LegalEntityClientDTO>> => {
    this.useLoadItemsPath("GetLegalEntityClientsByEmployeeGroups");
    return await this.loadItems(propsFilter);
  };
}
